import React from 'react';
import ThemeCardList from './ThemeCardList';
import ThemeCard from './ThemeCard';
import CollectionSubMenuTitle from './CollectionSubMenuTitle';
import __ from '../utils/translator';

export default props => (
  <React.Fragment>
    <CollectionSubMenuTitle>{__(':length themes available', { length: props.themes.length })}</CollectionSubMenuTitle>
    <ThemeCardList style={{ height: '14.5rem', }}>
      <div style={{ width: '.875rem' }} />
      {props.themes.map(theme => (
        <ThemeCard
          key={theme.id}
          theme={theme}
          status={theme.status}
          style={{ flex: '0 0 19.25rem', }}
          containerStyle={{ width: '18.75rem', }}
        />
      ))}
      <div style={{ width: '.875rem' }} />
    </ThemeCardList>
  </React.Fragment>
);
